export default "__VITE_ASSET__C3amjHA7__"